function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.43835 11.429C4.4494 11.5475 4.46388 11.6628 4.47799 11.7781L0 13.6728C0 13.6728 2.08615 14.2074 4.71736 13.0704C4.71736 13.0708 4.71774 13.0716 4.71813 13.0728C3.40804 13.7035 1.89099 14.3243 1.89099 14.3243C1.89099 14.3243 3.01048 14.6806 5.03145 14.0794C5.08252 14.2138 5.13817 14.3427 5.19421 14.4704C4.82828 14.689 4.57252 14.8394 4.57252 14.8394C4.57252 14.8394 4.911 14.9112 5.41376 14.9344C7.60854 19.2449 12.6514 20.1231 13.7461 20.2164C13.7461 20.2164 17.477 20.382 17.7614 23.7262C17.7522 24.6403 16.7158 25.7522 14.1589 26H19.9249C19.9249 26 18.0335 25.4119 18.0335 23.6165C18.0335 21.3647 24.3762 15.2169 36 18.0153C36 18.0153 33.6989 17.1052 30.802 15.9115C33.8033 14.3918 34.2039 12.4408 35.1729 10.7359C32.1643 15.1953 25.6638 13.5096 23.5914 12.8286C21.644 11.9496 20.0739 11.1764 19.4763 10.728C17.3505 9.13325 16.6956 7.78391 16.0023 5.97814C12.6651 -1.78874 7.94244 0.238463 7.94244 0.238463C7.9211 0.26719 7.90166 0.294719 7.88031 0.321849L4.579 0.397256L6.42805 2.45478C5.35239 4.25217 4.67315 6.08547 4.45664 8.36004C4.32743 9.95275 4.43835 11.429 4.43835 11.429ZM8.38041 2.11166C8.38041 2.11166 9.40309 3.66607 11.8552 3.68044C11.4469 3.87554 9.06766 4.2027 8.38041 2.11166Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 0,
  y1: 0,
  x2: 36,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5C6AC4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8977FF"
})));

var SvgSolveway = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSolveway, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/solveway.06b27284.svg";
export { ForwardRef as ReactComponent };